import Pusher, {Channel} from 'pusher-js'

type PusherChannel = Pick<Channel, 'bind' | 'unbind'>

/** Returned when no app key is configured (E2E/CI) so nothing dials Pusher. */
const inertChannel: PusherChannel = {
    bind: () => inertChannel as Channel,
    unbind: () => inertChannel as Channel,
}

class PusherService {
    private static instance: PusherService | null = null
    private client: Pusher | null = null

    private constructor() {}

    public static getInstance(): PusherService {
        if (!PusherService.instance) {
            PusherService.instance = new PusherService()
        }
        return PusherService.instance
    }

    private getClient(): Pusher | null {
        if (!window.pusherAppKey) {
            return null
        }

        if (!this.client) {
            this.client = new Pusher(window.pusherAppKey, {
                cluster: window.pusherAppCluster,
            })
        }
        return this.client
    }

    public subscribe(channelName: string): PusherChannel {
        return this.getClient()?.subscribe(channelName) ?? inertChannel
    }

    public unsubscribe(channelName: string): void {
        this.client?.unsubscribe(channelName)
    }

    public disconnect(): void {
        if (this.client) {
            this.client.disconnect()
            this.client = null
        }
    }
}

export default PusherService
